<script>
    export let data;
    export let height = '33vw';
    export let apply = true;
    export let topbottomMargin = '0.992vw 0vw';
    export let marginFor = '0vw';
    export let headingTop ='24.4vw';
    export let headingLeft ='5.59vw';
    export let rightMargin='1.323vw';
</script>

<div class="desktop">
    <div style="width: 88.815vw;margin:auto;padding:0 1vw;height:{height}">
        <div
            style="display: flex;align-items:center;justify-content: space-between;"
        >
            <div style="position: relative;">
                <div style="display:flex;align-items: center;margin-top:{marginFor}">
                    <h1
                        style="color:rgba(0, 32, 75, 1);font-size:1.191vw;margin-right:{rightMargin};opacity: 0.3;margin-top: 12.2vw;"
                    >
                        {data.number}
                    </h1>
                    <h1
                        style="color: rgba(124, 193, 255, 0.2);font-size: 14.560vw;font-weight: bold;padding-top: 12vw;"
                    >
                        {data.for}
                    </h1>
                </div>

                <div
                    style="    position: absolute;
                top: {headingTop};
                left:{headingLeft} ;"
                >
                    {#each data.points as point}
                        <div>
                            <h1
                                style="font-size:1.985vw;color:rgba(75, 154, 215, 1);text-transform: uppercase;"
                            >
                                {point.title}
                            </h1>
                            <div
                                style="width:38.8vw; margin:{topbottomMargin}"
                            >
                                <p style="font-size:1.191vw;    line-height: 1.280vw;">
                                    {point.description}
                                </p>
                            </div>
                            {#if apply}
                                <div
                                    on:click={() =>
                                        (location.href = '/applyProgram')}
                                    style="cursor:pointer;    margin-top: 1.8vw;"
                                >
                                    <p
                                        style="margin: 0;color:rgba(75, 154, 215, 1);font-size: 0.926vw;"
                                    >
                                        {point.action}
                                    </p>
                                    <div style="width: 5.3vw;">
                                        <img
                                            src={point.goahead}
                                            alt=""
                                            width="100%"
                                        />
                                    </div>
                                </div>
                            {/if}
                        </div>
                    {/each}
                </div>
            </div>
            <div  style="position: relative;">
                <div
                    style="width: 17.281vw;position: absolute;top: -3vw;right: 11vw;"
                >
                    <img src={data.src1} alt="" width="100%" />
                </div>
                <div
                    style="width: 16.222vw;position: absolute;top: 17vw;right: 10.5vw;"
                >
                    <img src={data.src2} alt="" width="100%" />
                </div>
                <div
                    style="width: 18.34vw;position: absolute;top: 9.2vw;right: -2vw"
                >
                    <img src={data.src3} alt="" width="100%" />
                </div>
            </div>
        </div>
    </div>
</div>
<div class="mobile">
    <div
        style="width: 88.815vw;margin:25vw auto 7vw;padding:0 1vw; height:160vw;"
    >
        <div style="position: relative;    height: 85vw;">
            <div style="display:flex;align-items: center;">
                <h1
                    style="color:rgba(0, 32, 75, 1);font-size:2.778vw;margin-right:1vw;opacity: 0.3;margin-top: 9vw;"
                >
                    {data.number}
                </h1>
                <h1
                    style="color: rgba(124, 193, 255, 0.2);font-size: 16.667vw;font-weight: bold;margin-top: -9vw; margin-left: 3vw;"
                >
                    {data.for}
                </h1>
            </div>
            <div style="position:absolute;top: 7.5vw;left: 8.5vw;">
                {#each data.points as point}
                    <div>
                        <h1
                            style="font-size: 5.556vw;
                            width: 75.556vw;
                            color: rgb(75, 154, 215);
                            text-transform: uppercase;
                            font-weight: 600;"
                        >
                            {point.title}
                        </h1>
                        <div style="width:75vw; margin: 5.25vw 0vw 8.334vw;">
                            <p style="font-size:3.056vw;text-align: justify;">
                                {point.description}
                            </p>
                        </div>
                        {#if apply}
                            <div
                                on:click={() =>
                                    (location.href = '/applyProgram')}
                            >
                                <p
                                    style="margin: 0;color:#4B9AD7;"
                                >
                                    {point.action}
                                </p>
                                <div style="margin-top: -2.5vw;">
                                    <img src={point.goahead} alt="" width="90vw" />
                                </div>
                            </div>
                        {/if}
                    </div>
                {/each}
            </div>
        </div>
        <div style="">
            <div
                style="width: 39.444vw;margin-left:7vw;"
            >
                <img src={data.src1} alt="" width="100%" />
            </div>
            <div
                style="width: 45.222vw;margin-left:11.5vw;margin-top: -18vw;"
            >
                <img src={data.src2} alt="" width="100%" />
            </div>
            <div
                style="width: 45.222vw;margin-left:37vw;margin-top: -61vw;"
            >
                <img src={data.src3} alt="" width="100%" />
            </div>
        </div>
    </div>
</div>

<style>
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
    }
</style>
